import React from "react";
import { Box, Card, CircularProgress, Typography } from "@mui/material";
import FactCheckIcon from "@mui/icons-material/FactCheck";

/**
 * Carga de un inventario: la tarjeta de la página con su título y el spinner
 * centrado. Sin datos a la vista, así que no se puede puntear contra un
 * inventario equivocado mientras llega el bueno
 */
const CargandoInventario = ({ titulo = "Contar inventario" }) => (
    <Box sx={{ width: "100%" }}>
        <Card sx={{ boxShadow: "0 2px 8px rgba(0,0,0,0.1)", borderRadius: 2 }}>
            <Box sx={{ p: 2, pb: 2 }}>
                <Typography
                    variant="h6"
                    sx={{ fontWeight: 700, color: "#212529", display: "flex", alignItems: "center", gap: 1 }}
                >
                    <FactCheckIcon sx={{ fontSize: 24 }} />
                    {titulo}
                </Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                <CircularProgress size={40} sx={{ color: "#cc071e" }} />
            </Box>
        </Card>
    </Box>
);

export default CargandoInventario;
